export function initLeCollage(){

    var leCollage = Barba.BaseView.extend({
        namespace: 'le-collage',
        onEnter: function() {
            // The new Container is ready and attached to the DOM.
        },
        onEnterCompleted: function() {
            // The Transition has just finished.
            console.log('le-collage');
            $('.video-popup-link').magnificPopup({
                type:'inline',
                midClick: true,
                fixedContentPos:true,
                callbacks: {
                    beforeOpen: function() {
                        var iframe = $(".white-popup iframe");
                        iframe.attr("src", iframe.data("videourl"))
                    },
                    beforeClose: function() {
                        var iframe = $(".white-popup iframe");
                        iframe.attr("src","")
                    }
                }


            });
        },
    });
    // Don't forget to init the view!
    leCollage.init();



}
